import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { WixOOISDKAdapter } from '@wix/bookings-adapter-ooi-wix-sdk/dist/src/WixOOISDKAdapter';
import { BookingsApi } from '../api/BookingsApi';
import { WidgetConfig } from '../../legacy/types';
import { Resources } from '../types/types';
import { WidgetViewModel } from '../viewModel/viewModel';
import {
  createOnFilterOptionSelectedAction,
  OnFilterOptionSelectedAction,
} from './onFilterOptionSelected/onFilterOptionSelected';
import {
  createOnDialogCloseAction,
  OnDialogCloseAction,
} from './onDialogClose/onDialogClose';
import {
  createHandelNavigationAction,
  NavigationAction,
} from './handleNavigation/handleNavigation';
import { createNavigateToServicePageAction } from './navigateToServicePage/navigateToServicePage';
import { createNavigateToBookPageAction } from './navigateToBookPage/navigateToBookPage';
import {
  CourseAvailabilityAction,
  createCourseAvailabilityAction,
} from './courseAvailability/courseAvailability';

export type WidgetActions = {
  onFilterOptionSelected: OnFilterOptionSelectedAction;
  onDialogClose: OnDialogCloseAction;
  navigateToServicePage: NavigationAction;
  navigateToBookPage: NavigationAction;
  getCourseAvailability: CourseAvailabilityAction;
};

export const createWidgetActions = ({
  widgetViewModel,
  filteredResources,
  wixSdkAdapter,
  bookingsApi,
  flowAPI,
  config,
  setProps,
  isAnywhereFlow = false,
}: {
  widgetViewModel: WidgetViewModel;
  filteredResources: Resources;
  wixSdkAdapter: WixOOISDKAdapter;
  bookingsApi: BookingsApi;
  flowAPI: ControllerFlowAPI;
  config: WidgetConfig;
  setProps: Function;
  isAnywhereFlow?: boolean;
}): WidgetActions => {
  const onFilterOptionSelected = createOnFilterOptionSelectedAction({
    widgetViewModel,
    filteredResources,
    wixSdkAdapter,
    setProps,
    flowAPI,
  });

  const onDialogClose = createOnDialogCloseAction({
    widgetViewModel,
    setProps,
    flowAPI,
    isAnywhereFlow,
  });

  const handleNavigation = createHandelNavigationAction({
    widgetViewModel,
    wixSdkAdapter,
    bookingsApi,
    flowAPI,
    config,
    setProps,
    isAnywhereFlow,
  });

  const navigateToServicePage =
    createNavigateToServicePageAction(handleNavigation);
  const navigateToBookPage = createNavigateToBookPageAction(handleNavigation);

  const courseAvailability = createCourseAvailabilityAction({
    widgetViewModel,
    filteredResources,
    wixSdkAdapter,
    setProps,
    flowAPI,
  });

  return {
    onFilterOptionSelected,
    onDialogClose,
    navigateToServicePage,
    navigateToBookPage,
    getCourseAvailability: courseAvailability,
  };
};
